import { render, staticRenderFns } from "./configuracao.vue?vue&type=template&id=af33f92c&"
import script from "./configuracao.vue?vue&type=script&lang=js&"
export * from "./configuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports